import { autoinject } from 'aurelia-framework';
import { AsyncErrorHandler, ViewLoadingFader } from 'lib/ui';
import { MooringProductionOrderListItemDto, MooringProductionStatusTranslation } from 'models/mooring';
import { MooringProductionOrderService } from 'services/mooring';
import { PubSub } from 'lib/event/PubSub';
import { FilterManager } from 'lib/tables/FilterManager';
import { Filters } from 'elements/Filter';
import { I18N } from 'aurelia-i18n';
import { CustomerService } from 'services/customer-service';

@autoinject
export class ProductionsView {
  protected productionOrders: MooringProductionOrderListItemDto[] = [];

  constructor(
    protected element: Element,
    protected fm: FilterManager,
    private mooringProductionOrderService: MooringProductionOrderService,
    private customerService: CustomerService,
    private t: I18N,
    private pubsub: PubSub
  ) {
    pubsub.sub('filter-manager:filter-changed', () => {
      void this.getAllProductionOrders();
    });
  }

  @AsyncErrorHandler
  async getCustomers() {
    const customres = await this.customerService.getAll();
    return customres.filter((x) => !x.IsDeleted);
  }

  @ViewLoadingFader
  async attached() {
    const customers = await this.getCustomers();
    this.fm.init({
      context: ProductionsView.name,
      storageKey: 'mooring-production-orders',
      filters: {
        customerIds: {
          type: 'checkbox',
          label: this.t.tr('general.customer'),
          name: 'customerIds',
          query: 'customerIds',
          originalData: customers,
          options: customers.map((x) => ({
            Name: x.Name,
            Id: x.Id,
          })),
          disabled: false,
        },
        statusIds: {
          type: 'checkbox',
          label: 'Status',
          name: 'statusIds',
          query: 'statusIds',
          originalData: MooringProductionStatusTranslation,
          options: Object.entries(MooringProductionStatusTranslation).map(([id, translation]) => ({
            Name: this.t.tr<string>(translation),
            Id: id,
          })),
          disabled: false,
        },
      } satisfies Filters,
      defaultFilters: {
        statusIds: true,
        customerIds: true,
      },
    });

    await this.getAllProductionOrders();
  }

  @AsyncErrorHandler
  async getAllProductionOrders() {
    const { data, headers } = await this.mooringProductionOrderService.getProductionOrders(this.fm.queryFilter);
    const record = headers.get('x-total-count');
    this.fm.paginationTotalRecords = record ? +record : 0;
    this.productionOrders = data;
  }

  protected detached() {
    this.pubsub.unsub();
  }
}
